export const SignatureConstants = {
  1: [
    { sort: 1, text: 1 },
    { sort: 2, text: 2 },
  ],
  2: [
    { sort: 1, text: 3 },
    { sort: 2, text: 4 },
  ],
  3: [
    { sort: 1, text: 5 },
    { sort: 2, text: 6 },
  ],
  4: [
    { sort: 1, text: 7 },
    { sort: 2, text: 8 },
  ],
  5: [
    { sort: 1, text: 11 },
    { sort: 2, text: 12 },
  ],
  6: [
    { sort: 1, text: 13 },
    { sort: 2, text: 14 },
  ],
  7: [
    { sort: 1, text: 15 },
    { sort: 2, text: 16 },
  ],
  8: [
    { sort: 1, text: 17 },
    { sort: 2, text: 18 },
  ],
  9: [
    { sort: 1, text: 19 },
    { sort: 2, text: 20 },
  ],
  10: [
    { sort: 1, text: 21 },
    { sort: 2, text: 22 },
  ],
  11: [
    { sort: 1, text: 23 },
    { sort: 2, text: 24 },
  ],
  12: [
    { sort: 1, text: 25 },
    { sort: 2, text: 27 },
  ],
  13: [
    { sort: 1, text: 28 },
    { sort: 2, text: 30 },
  ],
  14: [
    { sort: 1, text: 31 },
    { sort: 2, text: 33 },
  ],
  15: [
    { sort: 1, text: 34 },
    { sort: 2, text: 36 },
  ],
  16: [
    { sort: 1, text: 37 },
    { sort: 2, text: 38 },
  ],
  17: [
    { sort: 1, text: 39 },
    { sort: 2, text: 40 },
  ], 
  18: [
    { sort: 1, text: 41 },
    { sort: 2, text: 42 },
  ],
  19: [
    { sort: 1, text: 43 },
    { sort: 2, text: 44 },
  ],
  20: [
    { sort: 1, text: 45 },
    { sort: 2, text: 46 },
  ],
  21: [
    { sort: 1, text: 47 },
    { sort: 2, text: 48 },
  ],
};